import axios from "axios";
import baseURL from "./../api";
class CryptoService {
    constructor() {
        this.time = new Date().getTime();
    }

    getCrypto(userType) {
        if(userType) {
            return axios.get(`${baseURL}/crypto/request?userType=${userType}`);
        } else {
            return axios.get(`${baseURL}/crypto/request`);

        }
    }
    getCryptoList(userType) {
        if(userType) {
            return axios.get(`${baseURL}/crypto?userType=${userType}`);
        } else {
            return axios.get(`${baseURL}/crypto`);

        }
    }
    createCryptoRequest(data,type) {
        if(type == 'buy') {
            return axios.post(`${baseURL}/crypto/request/buy?${this.time}`,data);
        } else {
            return axios.post(`${baseURL}/crypto/request/sell?${this.time}`,data);
        }
       
    }

    viewCrypto(id) {
        return axios.get(`${baseURL}/crypto/request/${id}`);
    }

    updateCryptoStatus(data,id,type) {
        console.log(type)
        if(type == 'buy') {
            return axios.put(`${baseURL}/crypto/request/${id}/buy/approve`,data);
        } else {
            return axios.put(`${baseURL}/crypto/request/${id}/sell/approve`,data);
        }
    }

    updateCryptoConfigs(data,id) {
        return axios.put(`${baseURL}/crypto/${id}`,data);
    }

    getCryptoconfig(id) {
        return axios.get(`${baseURL}/crypto/${id}`);
    }

}   

export default new CryptoService();